import { Skeleton } from "@/components/ui/skeleton.tsx";

export function PageSkeleton() {
  return (
    <div role="status" aria-label="页面加载中" className="flex flex-col gap-4">
      <Skeleton className="h-7 w-40" />
      <div className="flex gap-2">
        <Skeleton className="h-8 w-64" />
        <Skeleton className="h-8 w-20" />
      </div>
      <div className="flex flex-col gap-2 rounded-md border p-3">
        {Array.from({ length: 6 }, (_, i) => (
          <Skeleton key={i} className="h-6 w-full" />
        ))}
      </div>
    </div>
  );
}
